module.exports = __webpack_public_path__ + "img/sk.fa3351e8.png";